<template>
    <div class="CShareFacebook">
        <CButton class="w-full" icon="facebook" label-class="sm:hidden" variant="facebook" @click="facebookLink">
            Facebook
        </CButton>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import { useSharing } from '@/composables/sharing/useSharing'

const props = defineProps<{
    url: string
}>()

const { objectToGetParams } = useSharing()

const facebookLink = () => {
    window.open(
        `https://www.facebook.com/sharer/sharer.php${objectToGetParams({
            u: props.url
        })}`,
        '__blank'
    )
}
</script>
